module.exports = __webpack_public_path__ + "static/img/lg-ess.99f039a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lg-ess.jpg
// module id = /9rx
// module chunks = 0